<section class="relative flex w-full h-screen overflow-hidden">
  <ng-container *ngTemplateOutlet="menuSection" />
  <div class="w-full overflow-hidden h-full flex flex-col">
    <app-top-bar
      [header]="currentChildMenu()?.name || currentMenu()?.name || ''"
      [parentHeader]="currentChildMenu() ? currentMenu()?.name : ''"
      [description]="currentChildMenu()?.description || currentMenu()?.description || ''" />
    <div #container class="flex-1 w-full h-full overflow-y-auto bg-base-200 p-6">
      <router-outlet />
    </div>
  </div>
</section>

<ng-template #menuSection>
  <app-side-menu
    title="관리자 시스템"
    class="md:block hidden shrink-0"
    [collapsed]="store.sidebarCollapsed()"
    (toggleCollapse)="store.toggleSidebar()">
    @for (menu of menus(); track $index) {
      @if (menu.children && menu.children.length > 0) {
        <app-side-menu-item-group
          [active]="currentMenu()?.name === menu.name"
          [label]="menu.name"
          [icon]="menu.icon!"
          [collapsed]="store.sidebarCollapsed()">
          @for (child of menu.children; track $index) {
            @let visible = child.super ? user()?.role === 'SUPER_ADMIN' : true;

            @if (visible) {
              <app-side-menu-item-child
                (click)="navigate(child)"
                [active]="currentChildMenu()?.name === child.name"
                [collapsed]="store.sidebarCollapsed()"
                >{{ child.name }}</app-side-menu-item-child
              >
            }
          }
        </app-side-menu-item-group>
      } @else {
        <app-side-menu-item
          (click)="navigate(menu)"
          [active]="currentMenu()?.name === menu.name"
          [icon]="menu.icon!"
          [collapsed]="store.sidebarCollapsed()"
          >{{ menu.name }}</app-side-menu-item
        >
      }
    }
  </app-side-menu>
</ng-template>
